/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerformata5portrait3Inputs */

const en_flyerformata5portrait3 = /** @type {(inputs: Flyerformata5portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

const de_flyerformata5portrait3 = /** @type {(inputs: Flyerformata5portrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

/**
* | output |
* | --- |
* | "A5" |
*
* @param {Flyerformata5portrait3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerformata5portrait3 = /** @type {((inputs?: Flyerformata5portrait3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerformata5portrait3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerformata5portrait3(inputs)
	return de_flyerformata5portrait3(inputs)
});
export { flyerformata5portrait3 as "flyerFormatA5Portrait" }